//@flow
import {  HiverAxios, showMessage } from 'h-commons';
import {CreateApiHandler} from '../../common/helpers/thunkMiddleware'
import { 
    PLAN_UPGRADE_INIT, 
    PLAN_UPGRADE_DONE, 
    PLAN_UPGRADE_FAILED, 
    PAYMENT_FAILED,
    GET_ACCOUNT_DETAILS_DONE,
    STRIPE_CARD_DETAILS_INIT, 
    STRIPE_CARD_DETAILS_DONE,
    STRIPE_CARD_DETAILS_FAILED,
    STRIPE_SCA_REQUIRED,
    CLEAR_STRIPE_SCA
} from './types';
import { confirmUpgradation } from '../actions';
import toPairs from 'lodash/toPairs';


export const changeCardOrUpgrade = (
    isUpdate: boolean,
    data: Object, 
    userSession: string | null, 
    backtoSavedCard: Function,
    planMeta: Object,
    isChargeBeeEnabled: boolean | false
) => (dispatch: Function) => {
    dispatch({
        type: (isUpdate) ? STRIPE_CARD_DETAILS_INIT : PLAN_UPGRADE_INIT
    });
    let invocationType = 'GET';
    let url = isUpdate ? '/stripe/change_cc' : '/stripe';
    url += toPairs(data).reduce((prev, current, idx) => {
        return prev + (idx === 0 ? `?${current[0]}=${current[1]}` : `&${current[0]}=${current[1]}`);
    }, '');
    if (isChargeBeeEnabled){
        url = isUpdate ? '/api/payment/card' : '/api/payment';
        invocationType = isUpdate ? 'PUT' : "POST";
    }
    HiverAxios({
        url,
        params: isChargeBeeEnabled ? data : {},
        type: invocationType,
        callback: (response) => {
            if (isUpdate) {
                const {requires_action, paymentIntent} = response.data; 
                if(requires_action && paymentIntent){
                    dispatch({
                        type: STRIPE_SCA_REQUIRED,
                        payload: { 
                            stripePaymentIntentSecretKey: paymentIntent.client_secret,
                            stripePaymentIntentId: paymentIntent.id,
                            stripePaymentMethodId: paymentIntent.payment_method
                        }
                    });
                    return ;
                }
                showMessage({
                    message: 'Saved successfully. This card will be used for all future transactions.',
                    type: 'success'
                });
                dispatch({
                    type: CLEAR_STRIPE_SCA
                });
                dispatch({
                    type: STRIPE_CARD_DETAILS_DONE
                });
                dispatch({
                    type : GET_ACCOUNT_DETAILS_DONE,
                    payload: response.data
                });
                typeof backtoSavedCard === "function" && backtoSavedCard();
            } else {
                const {requires_action,paymentIntent} = response.data; 
                if(requires_action && paymentIntent){
                    dispatch({
                        type: STRIPE_SCA_REQUIRED,
                        payload: { 
                            stripePaymentIntentSecretKey: paymentIntent.client_secret,
                            stripePaymentIntentId: paymentIntent.id,
                            stripePaymentMethodId: paymentIntent.payment_method
                        }
                    });
                    return ;
                }
               dispatch(confirmUpgradation(userSession,planMeta));
            }
            dispatch({ 
                type: PLAN_UPGRADE_DONE
            });
        },
        onfail: (e) => {
            dispatch({ type: CLEAR_STRIPE_SCA });
            dispatch({
                type: PLAN_UPGRADE_FAILED,
                payload: e.data
            });

            var msg = "response"in e && e.response.data.message  ? e.response.data.message: "Card was declined"
            
            !isUpdate ? dispatch({
                type: PAYMENT_FAILED,
                payload: msg
            }): dispatch({
                type: STRIPE_CARD_DETAILS_FAILED,
                payload: msg
            });
        }
    });
}


export const saveCreditCard =  CreateApiHandler(({data}) => {
    return new Promise((res, rej) => {
        let url = '/stripe/subscribe';
        const body = {...data}
        HiverAxios({
            url,
            type: 'POST',
            params:body,
            callback:(response) => { res(response.data) },
            onfail: (err) => {rej(err)}
        })
    })
}, 'SAVE_CREDIT_CARD', { showErrorSnackbar: false });